import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-552e1d77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "volume-head-content" }
const _hoisted_2 = { class: "volume-head-title" }
const _hoisted_3 = { width: "120" }
const _hoisted_4 = { width: "120" }
const _hoisted_5 = { width: "120" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "XS", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "0-40cm", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "S", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "41-60cm", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "M", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "61-100cm", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "L", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "101-140cm", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "XL", -1))
const _hoisted_15 = { rowspan: "2" }
const _hoisted_16 = { class: "cursor-pt" }

import { t } from '@/plugins/i18n'
import { QuestionFilled } from '@element-plus/icons-vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    effect: "light",
    "popper-class": "tool-tip-no-border"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('库存保管费')), 1),
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_3, _toDisplayString(_unref(t)('尺寸规格')), 1),
            _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(t)('3边总尺寸')), 1),
            _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t)('库存保管天数')), 1),
            _createElementVNode("th", null, _toDisplayString(_unref(t)('单价')), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("td", null, _toDisplayString(_unref(t)('0-180日')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('{price}元/点/日', {price: '0.01'})), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(t)('181日以上')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('{price}元/点/日', {price: '0.02'})), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("td", null, _toDisplayString(_unref(t)('0-180日')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('{price}元/点/日', {price: '0.04'})), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(t)('181日以上')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('{price}元/点/日', {price: '0.05'})), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _hoisted_11,
            _createElementVNode("td", null, _toDisplayString(_unref(t)('0-180日')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('{price}元/点/日', {price: '0.20'})), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(t)('181日以上')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('{price}元/点/日', {price: '0.24'})), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("td", null, _toDisplayString(_unref(t)('0-180日')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('{price}元/点/日', {price: '0.60'})), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(t)('181日以上')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('{price}元/点/日', {price: '0.72'})), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_14,
            _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(t)('141cm以上')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('0-180日')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('{price}元/点/日', {price: '0.85'})), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(t)('181日以上')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(t)('{price}元/点/日', {price: '1.02'})), 1)
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_16, [
        _createTextVNode(_toDisplayString(_unref(t)('保管费计费尺寸')) + " ", 1),
        _createVNode(_component_el_icon, { color: "#999" }, {
          default: _withCtx(() => [
            _createVNode(_unref(QuestionFilled))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})